"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const date_fns_1 = require("date-fns");
const react_1 = require("react");
const react_final_form_1 = require("react-final-form");
const react_redux_1 = require("react-redux");
const react_toastify_1 = require("react-toastify");
const components_1 = require("components");
const config_1 = require("config");
const utils_1 = require("utils");
const context_1 = require("../../../../../context");
const actions_1 = require("../../actions");
const components_2 = require("../../components");
const reducer_1 = require("../../reducer");
const ShowTerms_1 = __importDefault(require("./ShowTerms"));
const maxDays = 9000; // 24 years
const minDays = 40000; // 109.5 Years
// Date Constants
const TODAY = (0, date_fns_1.subDays)(new Date(), minDays);
const FROM_TODAY_MAX = (0, date_fns_1.addDays)(new Date(), maxDays); // 24 years
const DATE_NOW = {
    month: TODAY.getMonth(),
    day: TODAY.getDate(),
    year: TODAY.getFullYear(),
};
const DATE_MAX = {
    month: FROM_TODAY_MAX.getMonth(),
    day: FROM_TODAY_MAX.getDate(),
    year: FROM_TODAY_MAX.getFullYear(),
};
function AuthBuyerForm({ submitFunc, onSubmitSuccess, applicationEnvironment, terms, submitButtonText, showTerms, waterFalling, prequalification, }) {
    const linkCCA = terms.filter((itm) => itm.text.includes('cca'));
    const linkPatAct = terms.filter((itm) => itm.text.includes('patriot'));
    const initVals = {
        shareWithFamily: 'N',
    };
    const [isAddAuthBuyer, setIsAddAuthBuyer] = (0, react_1.useState)(null);
    const screen = (0, react_redux_1.useSelector)(reducer_1.selectors.offerScreen);
    const dispatch = (0, react_redux_1.useDispatch)();
    const { analytics } = (0, react_1.useContext)(context_1.AnalyticsContext);
    const handleRadioShareWithFamily = (evt) => {
        const tmpVal = evt.target.value;
        if (tmpVal === 'Y') {
            setIsAddAuthBuyer(true);
        }
        if (tmpVal === 'N') {
            setIsAddAuthBuyer(false);
        }
    };
    const handleViewMoreOffers = () => {
        dispatch((0, actions_1.setOfferScreen)('OTHER OFFERS'));
    };
    const formValidate = (values) => {
        if (values) {
            const errors = {};
            if (values.shareWithFamily === 'Y') {
                if (!values.firstName) {
                    errors.firstName = 'Required';
                }
                if (!values.lastName) {
                    errors.lastName = 'Required';
                }
                if (!values.relationship) {
                    errors.relationship = 'Required';
                }
                if (!values.dateOfBirth) {
                    errors.dateOfBirth = 'Required';
                }
            }
            if (values.shareWithFamily === 'N') {
                if (!values.signedAgreed) {
                    errors.signedAgreed = 'Required';
                }
            }
            if (Object.keys(errors).length) {
                return errors;
            }
            else {
                return undefined;
            }
        }
    };
    const createSubmitObject = (values) => {
        if (values.shareWithFamily === 'Y') {
            const fmtDOB = (0, utils_1.formatISODateString)(values.dateOfBirth);
            return {
                authorizedBuyer: {
                    firstName: values.firstName,
                    lastName: values.lastName,
                    relationship: values.relationship,
                    dateOfBirth: fmtDOB,
                },
                shareWithFamily: values.shareWithFamily,
                signedAgreed: values.signedAgreed,
            };
        }
        else {
            return {
                shareWithFamily: values.shareWithFamily,
                signedAgreed: values.signedAgreed,
            };
        }
    };
    const formSubmit = (0, react_1.useCallback)(async (values) => {
        if (values) {
            const isFormValid = formValidate(values);
            if (isFormValid === undefined) {
                const submitObj = createSubmitObject(values);
                if (submitFunc) {
                    const resp = await submitFunc(submitObj);
                    onSubmitSuccess(resp);
                }
            }
            else {
                (0, react_toastify_1.toast)(`Form has errors: ${JSON.stringify(isFormValid)}`, {
                    type: 'error',
                });
                // Form IS NOT VALID
                return isFormValid;
            }
        }
    }, [isAddAuthBuyer]);
    const logToAnalytics = () => {
        if (prequalification.offers && prequalification.offers.length > 1) {
            analytics?.track('ViewMoreOffersButtonShown', {
                product: 'Alphaeon Credit',
            });
            (0, utils_1.reportAction)('ViewMoreOffersButtonShown', {
                componentName: 'AuthBuyerForm',
                actionType: 'ViewMoreOffersButtonShown',
                actionURL: window.location.pathname,
                actionData: {
                    product: 'Alphaeon Credit',
                },
            });
        }
        analytics?.track('OfferPresentedBread', {});
        (0, utils_1.reportAction)('OfferPresentedBread', {
            componentName: 'AuthBuyerForm',
            actionType: 'OfferPresentedBread',
            actionURL: window.location.pathname,
        });
    };
    (0, react_1.useEffect)(() => {
        (0, utils_1.scrollToTop)();
        logToAnalytics();
    }, []);
    // Default
    return ((0, jsx_runtime_1.jsx)("div", { children: screen === 'PRESENTED OFFER' ? ((0, jsx_runtime_1.jsx)(react_final_form_1.Form, { initialValues: { ...initVals }, onSubmit: formSubmit, render: ({ handleSubmit, submitting, values, form }) => {
                const signedAgreed = values.signedAgreed;
                const yesAuthBuyer = values.shareWithFamily === 'Y' ? true : false;
                const isDisabled = submitting ||
                    (!yesAuthBuyer && !signedAgreed) ||
                    (yesAuthBuyer &&
                        (!values.firstName ||
                            !values.lastName ||
                            !values.relationship ||
                            !values.dateOfBirth ||
                            !signedAgreed));
                // Reset if not adding an auth buyer
                if (!isAddAuthBuyer) {
                    form.change('firstName', undefined);
                    form.change('lastName', undefined);
                    form.change('relationship', undefined);
                    form.change('dateOfBirth', undefined);
                }
                return ((0, jsx_runtime_1.jsxs)("form", { noValidate: true, onSubmit: handleSubmit, className: `forms-container`, children: [applicationEnvironment?.authorizedBuyersEnabled === true && ((0, jsx_runtime_1.jsxs)("div", { className: "preQualification-form radio-group", children: [(0, jsx_runtime_1.jsx)("div", { className: "info-contain", children: "Want to Add an Authorized Buyer?" }), (0, jsx_runtime_1.jsxs)("fieldset", { onChange: handleRadioShareWithFamily, children: [(0, jsx_runtime_1.jsx)(react_final_form_1.Field, { name: "shareWithFamily", label: false, component: components_1.InputRadio, type: "radio", value: "Y", radiotext: "Yes" }), (0, jsx_runtime_1.jsx)(react_final_form_1.Field, { name: "shareWithFamily", label: false, component: components_1.InputRadio, type: "radio", value: "N", radiotext: "No" })] }), isAddAuthBuyer ? ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(react_final_form_1.Field, { name: "firstName", label: 'First Name', component: components_1.InputText, placeholder: "", type: "text", required: yesAuthBuyer ? true : false }), (0, jsx_runtime_1.jsx)(react_final_form_1.Field, { name: "lastName", label: 'Last Name', component: components_1.InputText, placeholder: "", type: "text", required: yesAuthBuyer ? true : false }), (0, jsx_runtime_1.jsx)(components_1.InputSelectNative, { name: "relationship", label: 'Relationship To Applicant', options: config_1.RELATIONSHIPS, required: yesAuthBuyer ? true : false }), (0, jsx_runtime_1.jsx)(react_final_form_1.Field, { placeholder: 'MM/DD/YYYY', name: 'dateOfBirth', label: 'Date of Birth', component: components_1.InputDateMask, required: yesAuthBuyer ? true : false, type: "tel", mask: Date, autofix: "pad", min: new Date(DATE_NOW.year, DATE_NOW.month, DATE_NOW.day), max: new Date(DATE_MAX.year, DATE_MAX.month, DATE_MAX.day), lazy: true, unmask: false }), (0, jsx_runtime_1.jsx)("div", { className: "authorized-buyer-text", children: "An authorized buyer is an individual you give permission to make purchases on your account. As the primary account holder, you are responsible for paying for all purchases made on this account, including any made by an authorized buyer." })] })) : null] })), (0, jsx_runtime_1.jsx)(ShowTerms_1.default, { showTerms: showTerms, linkPatAct: linkPatAct, linkCCA: linkCCA }), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(components_1.Button, { type: "submit", "data-testid": "authbuyer-form-submit-button", className: `button-primary button-warn ${isDisabled ? 'is-disabled' : 'is-enabled'} ${submitting || submitting ? 'in-progress' : ''}`, invalid: isDisabled || waterFalling, submitting: waterFalling, disabledToolTip: "Please fill out all required fields and correct any validation errors.", children: submitButtonText }), prequalification.offers &&
                                    prequalification.offers.length > 1 && ((0, jsx_runtime_1.jsx)("div", { role: "button", className: "text-as-button mar-t-16 mar-left-18", onClick: handleViewMoreOffers, tabIndex: 0, onKeyDown: (e) => {
                                        if (e.key === 'Enter') {
                                            handleViewMoreOffers();
                                        }
                                    }, children: "VIEW MORE OFFERS" }))] })] }));
            } })) : ((0, jsx_runtime_1.jsx)(components_2.MoreOffers, { offers: prequalification.offers })) }));
}
exports.default = AuthBuyerForm;
